import { createComponents } from '@vfde-brix/ws10/core';
import { FORM_SUGGEST_INPUT_BASE_CLASSNAME } from './Constants';
import { createFormSuggestInput } from './FormSuggestInput';
createComponents(FORM_SUGGEST_INPUT_BASE_CLASSNAME, createFormSuggestInput, {
    onChange: function () { },
});
